import React from "react";

const Wrap = ({ label, children }) => (
  <div className="rounded-md border-2 border-kirana-border bg-kirana-cream/70 p-3" data-testid="game-diagram">
    <p className="mb-2 text-xs font-bold uppercase tracking-wide text-kirana-brown/60">{label}</p>
    <svg viewBox="0 0 200 90" className="h-24 w-full">{children}</svg>
  </div>
);

export const GameDiagram = ({ type }) => {
  switch (type) {
    case "kabaddi":
      return (
        <Wrap label="Kabaddi court">
          <rect x="10" y="10" width="180" height="70" fill="none" stroke="#2D241E" strokeWidth="2" />
          <line x1="100" y1="10" x2="100" y2="80" stroke="#C84B31" strokeWidth="2" strokeDasharray="4 3" />
          {[28, 45, 62].map((y, i) => <circle key={i} cx="55" cy={y} r="5" fill="#2D6A4F" />)}
          {[28, 45, 62].map((y, i) => <circle key={i} cx="145" cy={y} r="5" fill="#E76F51" />)}
          <text x="34" y="76" fontSize="9" fill="#2D241E">Raider crosses the line →</text>
        </Wrap>
      );
    case "khokho":
      return (
        <Wrap label="Kho-Kho line">
          <line x1="20" y1="48" x2="180" y2="48" stroke="#2D241E" strokeWidth="2" />
          {[40, 70, 100, 130, 160].map((x, i) => (
            <polygon key={i} points={`${x},40 ${x - 6},56 ${x + 6},56`} fill={i % 2 ? "#457B9D" : "#E9C46A"} stroke="#2D241E" />
          ))}
          <circle cx="30" cy="22" r="5" fill="#C84B31" />
          <text x="40" y="25" fontSize="8" fill="#2D241E">active chaser</text>
        </Wrap>
      );
    case "lagori":
      return (
        <Wrap label="Seven stones + ball">
          {[0, 1, 2, 3, 4, 5, 6].map((i) => (
            <ellipse key={i} cx="60" cy={78 - i * 9} rx={22 - i * 2} ry="5" fill="#9C6644" stroke="#2D241E" />
          ))}
          <circle cx="150" cy="52" r="12" fill="#E63946" stroke="#2D241E" strokeWidth="2" />
          <text x="120" y="82" fontSize="9" fill="#2D241E">ball →</text>
        </Wrap>
      );
    case "stapu":
      return (
        <Wrap label="Hopscotch boxes">
          {[[82, 58, "1"], [82, 36, "2"], [66, 14, "3"], [98, 14, "4"]].map(([x, y, n], i) => (
            <g key={i}>
              <rect x={x} y={y} width="18" height="18" fill="#FDF6E3" stroke="#2D241E" strokeWidth="2" />
              <text x={x + 6} y={y + 13} fontSize="10" fill="#2D241E">{n}</text>
            </g>
          ))}
          <circle cx="122" cy="66" r="4" fill="#C84B31" />
          <text x="130" y="69" fontSize="8" fill="#2D241E">stone</text>
        </Wrap>
      );
    case "gilli":
      return (
        <Wrap label="Gilli + danda">
          <rect x="26" y="46" width="72" height="7" rx="3" fill="#8B5A2B" stroke="#2D241E" transform="rotate(-8 26 46)" />
          <rect x="120" y="42" width="28" height="7" rx="3" fill="#DDA15E" stroke="#2D241E" />
          <text x="30" y="74" fontSize="9" fill="#2D241E">danda</text>
          <text x="120" y="68" fontSize="9" fill="#2D241E">gilli</text>
        </Wrap>
      );
    case "kanche":
      return (
        <Wrap label="Marble target">
          <circle cx="110" cy="46" r="30" fill="none" stroke="#2D241E" strokeWidth="2" strokeDasharray="4 3" />
          {[[100, 40], [120, 52], [110, 34]].map(([x, y], i) => <circle key={i} cx={x} cy={y} r="5" fill="#457B9D" />)}
          <circle cx="40" cy="46" r="6" fill="#E9C46A" stroke="#2D241E" />
          <text x="24" y="74" fontSize="9" fill="#2D241E">aim & flick →</text>
        </Wrap>
      );
    case "lattoo":
      return (
        <Wrap label="Wrap string & spin">
          <polygon points="100,28 118,54 100,76 82,54" fill="#8B5A2B" stroke="#2D241E" strokeWidth="2" />
          <line x1="100" y1="28" x2="100" y2="16" stroke="#2D241E" strokeWidth="2" />
          <path d="M100 40 q22 6 18 24" fill="none" stroke="#C84B31" strokeWidth="2" />
        </Wrap>
      );
    case "kite":
      return (
        <Wrap label="Kite + charkhi">
          <polygon points="66,14 88,42 66,70 44,42" fill="#E63946" stroke="#2D241E" strokeWidth="2" />
          <line x1="66" y1="42" x2="66" y2="80" stroke="#2D241E" />
          <line x1="66" y1="70" x2="150" y2="80" stroke="#2D241E" />
          <circle cx="156" cy="80" r="9" fill="#F4A261" stroke="#2D241E" strokeWidth="2" />
          <text x="112" y="58" fontSize="9" fill="#2D241E">charkhi</text>
        </Wrap>
      );
    default:
      return null;
  }
};
